// extracted by mini-css-extract-plugin
export default {"container":"U9q0S","contents":"zQ7UF","invoiceTabs":"vNtzj"};